import React, { Fragment } from 'react';
import {
  Intro,
  // PagerButton,
  Video
} from "cvs-core"
import video from '../../assets/videos/U1-T1-2-1.mp4';

const videoFiles = {
  sources: [
    {
      src: video
    }
  ],
  tracks: [
    {
      src: '',
      kind: 'captions',
      label: 'test label'
    }
  ]
}

export default {
  title: 'Cotton Candy Sewer Juice',
  path: '/videos/video-one',
  content: (
    <Fragment>
      <Intro direction="Press the play button to start. Once the video is complete, the continue button will be enabled." title="Cotton Candy Sewer Juice" />
      <Video videoFiles={videoFiles} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/videos/VideoOne.js